const I = /^#?\s*([a-z]+)?[\s-]*(\d{1,9})$/i, k = /^([a-z]+)-(\d+)$/i;
function d(e) {
  const t = I.exec(e.trim());
  return t ? {
    prefix: t[1] ? t[1].toLowerCase() : null,
    number: t[2].replace(/^0+(?=\d)/, "")
  } : null;
}
function O(e, t) {
  const r = k.exec(e);
  return !r || t.prefix && r[1].toLowerCase() !== t.prefix ? !1 : r[2] === t.number;
}
function w(e, t) {
  const r = d(e);
  return r ? t.filter(
    (s) => !s.archived && !!s.issueKey && O(s.issueKey, r)
  ).sort((s, o) => {
    const c = s.updated ? Date.parse(s.updated) : 0;
    return (o.updated ? Date.parse(o.updated) : 0) - c;
  }) : [];
}
function A(e, t) {
  return !!e.title?.toLowerCase().includes(t) || !!e.issueKey?.toLowerCase().includes(t) || !!e.description?.toLowerCase().includes(t) || !!e.id?.toLowerCase().includes(t);
}
const l = 80, f = 70, p = 60, E = 50, C = 40, S = 30, T = 20, i = 0, R = 50;
function m(e, t) {
  const r = e.title.toLowerCase();
  if (r === t) return l;
  if (r.startsWith(t)) return f;
  const s = r.indexOf(t);
  if (s > 0) {
    const o = r[s - 1];
    return /[\s\-_/.:]/.test(o) ? p : E;
  }
  return e.key?.toLowerCase().includes(t) ? C : e.subtitle?.toLowerCase().includes(t) ? S : e.detail?.toLowerCase().includes(t) ? T : i;
}
function x(e, t) {
  let r = 0;
  for (const s of t) {
    const o = m(e, s);
    if (o === i) return i;
    r += o;
  }
  return r / t.length;
}
function K(e, t) {
  if (e.score !== t.score) return t.score - e.score;
  const r = (t.entry.updatedAt ?? 0) - (e.entry.updatedAt ?? 0);
  return r !== 0 ? r : e.entry.title.localeCompare(t.entry.title);
}
function h(e, t, r = {}) {
  const s = r.limit ?? R, o = t.trim();
  if (!o)
    return [...e].sort((n, a) => (a.updatedAt ?? 0) - (n.updatedAt ?? 0) || n.title.localeCompare(a.title)).slice(0, s);
  const c = o.toLowerCase().split(/\s+/).filter(Boolean), u = d(o) ? w(
    o,
    e.filter((n) => n.kind === "tracker").map((n) => ({
      id: n.id,
      issueKey: n.key ?? null,
      updated: n.updatedAt ? new Date(n.updatedAt).toISOString() : null,
      entry: n
    }))
  ).map((n) => n.entry) : [], L = new Set(u.map((n) => `${n.kind}:${n.id}`)), _ = e.filter((n) => !L.has(`${n.kind}:${n.id}`)).map((n) => ({ entry: n, score: x(n, c) })).filter((n) => n.score > i).sort(K).map((n) => n.entry);
  return [...u, ..._].slice(0, s);
}
const y = {
  titleExact: l,
  titlePrefix: f,
  titleWord: p,
  titleSubstring: E,
  key: C,
  subtitle: S,
  detail: T
};
export {
  y as QUICK_OPEN_SCORES,
  w as findTrackersByIssueKey,
  O as matchesIssueKey,
  A as matchesTrackerText,
  d as parseIssueKeyQuery,
  h as rankQuickOpenEntries
};
//# sourceMappingURL=quick-open.js.map
